// extracted by mini-css-extract-plugin
export default {"ExtensionGallery":"_ExtensionGallery--j7D8S"};